import { OrderDirection } from "common/contracts/order-direction";

export default class PermissionOrderParameters {
  public orderBy?: "CreatedDate" | "DisabledDate" | "Resource";
  public orderDir?: OrderDirection;

  constructor(
    orderBy?: "CreatedDate" | "DisabledDate" | "Resource",
    orderDir?: OrderDirection,
  ) {
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

  public asSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.orderBy) searchParams.append("orderBy", this.orderBy);
    if (this.orderDir) searchParams.append("orderDir", this.orderDir);
    return searchParams;
  }

  public isEqualTo(other: PermissionOrderParameters | undefined): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }
}
